const code =
  '#include<stdio.h>\nint main()\n{\n\t//Code\n\tprintf("Hello World");\n\treturn 0;\n}';

export default code;
